import { Blockchain } from "@rarible/api-client"
import { defineChain } from "viem"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const robinhood = defineChain({
  id: 4663,
  name: "Robinhood Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Ethereum",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["https://rpc.mainnet.chain.robinhood.com"] },
  },
  blockExplorers: {
    default: {
      name: "Robinhood Chain Explorer",
      url: "https://robinhoodchain.blockscout.com",
    },
  },
  testnet: false,
})

export const robinhoodConfig: StaticEthereumBlockchainConfig = {
  name: "Robinhood Chain",
  icon: "/images/blockchains/robinhood.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://robinhood-api.rarible.org",
  chainId: robinhood.id,
  blockchain: Blockchain.ROBINHOOD,
  chainName: robinhood.name,
  treasury: "0x74Fbc141095A34a7daEc2001600D64968Dbd46B4",
  exchange: {
    v2: "0x5322be7A90AAa2F028d7f03A780C10F716CCB247",
    wrapper: "0x4121675a069B8De388e49216Ec045D3A64cF836c",
  },
  transferProxies: {
    nft: "0xcFde5dba228968A84c853552f1db5a228442b542",
    erc721Lazy: "0xCEdDC96608a2eC0D9DdbCeCDb028a1cB2252041e",
    erc20: "0x2fA7f920F2776fCd7105147c51de45bb14A7e8a0",
  },
  blockExplorers: [
    {
      url: "https://robinhoodchain.blockscout.com",
      icon: "/images/scanner.svg",
      adress: "https://robinhoodchain.blockscout.com/address/${adrress}",
    },
  ],
  rpcUrls: [
    {
      url: "https://rpc.mainnet.chain.robinhood.com",
      isPublic: true,
    },
  ],
  privateRpcNodeSlug: "robinhood-node",
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("ROBINHOOD:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ethereum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ROBINHOOD:0x0bd7d308f8e1639fab988df18a8011f41eacad73"),
    symbol: "WETH",
    name: "Wrapped Ethereum",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: false,
  viem: robinhood,
}

export const getRobinhoodConfig = (): StaticEthereumBlockchainConfig =>
  robinhoodConfig
